import { DI } from '@intigral/constant/config/DIContainer';
import { IRewardService } from '@intigral/domain/lib/application/services/RewardService';
import { container } from '@intigral/domain/lib/DataDomain';
import user from '../../../helpers/user';
import moment from 'moment';
import { isSDKInitialized } from './LiveLikeService';
import { isGuestUser } from '../../../config/guestMode';

export const fetchBackendBadges = async () => {
    if (isGuestUser(user.getUserInfo())) {
        return [];
    }
    try {
        const response = await container
            .resolve<IRewardService>(DI.SERVICES.IRewardService)
            .getBadges(user.getIdentityToken(), user.getAPIKey());
        return response?.results || [];
    } catch (e) {
        return [];
    }
};

export const fetchSDKEarnedBadges = async (sdkClient, profileId) => {
    if (!isSDKInitialized(sdkClient)) return [];

    try {
        const response = await sdkClient.getProfileBadges({ profileId });
        return response?.results.map((el) => el.badge).filter(Boolean) || [];
    } catch (e) {
        return [];
    }
};

export const fetchSDKAllBadges = async (sdkClient) => {
    if (!isSDKInitialized(sdkClient)) return [];

    try {
        const response = await sdkClient.getApplicationBadges();
        return response?.results || [];
    } catch (e) {
        return [];
    }
};

export const fetchSDKEarnedBadgesByDate = async (sdkClient, profileId, durationInHours) => {
    if (!isSDKInitialized(sdkClient)) return [];

    try {
        const startTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const endDate = moment().subtract(durationInHours, 'hours').format('YYYY-MM-DD HH:mm:ss');
        const response = await sdkClient.getProfileBadges({
            profileId,
            createdSince: endDate,
            createdUntil: startTime,
        });
        return response?.results.map((el) => el.badge).filter(Boolean) || [];
    } catch (e) {
        return [];
    }
};
